import { app } from "api";
import { useQuery } from "react-query";

async function getReviews() {
  let uid = app.auth().currentUser?.uid;
  let reviews = (
    await app.firestore().collection("reviews").where("labId", "==", uid).get()
  ).docs.map((i) => i.data());

  const userIds = Array.from(new Set(reviews.map((i) => i.userId)));
  const promises = userIds.map((userId: string) =>
    app
      .firestore()
      .collection("users")
      .doc(userId)
      .get()
      .then((res) => res.data())
  );
  const users = await Promise.all(promises);
  return reviews.map((review) => {
    review["user"] = users.find((user) => user?.id === review.userId);
    return review;
  });
}

export function useReviews() {
  return useQuery(["reviews"], getReviews);
}
